import React, { useEffect } from "react";

import { object, number } from "prop-types";

import StoryElements from "../story-elements";

const ImmersiveStory = ({ story, index }) => {
  useEffect(() => {
    let headerElement, footerElement;
    if (document) {
      headerElement = document.getElementsByClassName("top-bar-container");
      footerElement = document.getElementById("footer");

      headerElement[0].style.display = "none";
      footerElement.style.display = "none";
    }

    if (headerElement[0]) {
      return () => {
        headerElement[0].style.display = "block";
        footerElement.style.display = "block";
      };
    }
  }, []);
  return <StoryElements story={story} cards={story.cards} index={index} isImmersiveStory={true} />;
};

ImmersiveStory.propTypes = {
  story: object,
  index: number
};

export default ImmersiveStory;
